var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"raised":"","width":"90%"}},[_c('baseSyncGrid',{attrs:{"query":"ZE_Aufteilung_Projektstunden"}}),_c('baseSyncGrid',{attrs:{"pagZeilen":20,"query":"Web_pers_Stempelungen"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }